import type { UserGroupListItemResponseDto } from "@/spz-api/model";

export interface UserGroupListItem {
  id: string;
  name: string;
  description: string | null;
  userCount: number;
  updatedAt: Date | null;
}

export const UserGroupTypes = {
  USER: "USER",
  USER_GROUP: "USER_GROUP",
} as const;

export type UserGroupTypes =
  (typeof UserGroupTypes)[keyof typeof UserGroupTypes];

export class UserGroupMapper {
  static toListItem(dto: UserGroupListItemResponseDto): UserGroupListItem {
    return {
      id: dto.id,
      name: dto.name,
      description: dto.description,
      userCount: dto.userCount,
      updatedAt: dto.updatedAt ? new Date(dto.updatedAt) : null,
    };
  }

  static toListItems(
    dtos: UserGroupListItemResponseDto[],
  ): UserGroupListItem[] {
    return dtos.map((userGroup) => UserGroupMapper.toListItem(userGroup));
  }
}
